const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
const isPhone = (v) => /^[0-9+()\-\s]{7,20}$/.test(v);
const MY_POSTCODE = /^\d{5}$/;
const SG_POSTCODE = /^\d{6}$/;

const tooLong = (v, max) => v.trim().length > max;

export const validateOrder = (order) => {
  const errors = {};
  const b = order.business;

  if (!b.namaPenuh.trim()) errors.namaPenuh = "Sila masukkan nama penuh.";
  else if (tooLong(b.namaPenuh, 60)) errors.namaPenuh = "Nama penuh terlalu panjang (maksimum 60 aksara).";

  if (b.jawatan.trim() && tooLong(b.jawatan, 60))
    errors.jawatan = "Jawatan terlalu panjang (maksimum 60 aksara).";

  if (!b.namaPerniagaan.trim())
    errors.namaPerniagaan = "Sila masukkan nama perniagaan atau syarikat.";
  else if (tooLong(b.namaPerniagaan, 70))
    errors.namaPerniagaan = "Nama perniagaan terlalu panjang (maksimum 70 aksara).";

  if (b.bidangBisnes.trim() && tooLong(b.bidangBisnes, 90))
    errors.bidangBisnes = "Bidang bisnes / moto terlalu panjang (maksimum 90 aksara).";

  if (!b.telefon.trim()) errors.telefon = "Sila masukkan nombor telefon.";
  else if (!isPhone(b.telefon.trim())) errors.telefon = "Nombor telefon tidak sah.";

  if (b.whatsapp.trim() && !isPhone(b.whatsapp.trim()))
    errors.whatsapp = "Nombor WhatsApp tidak sah.";

  if (b.email.trim() && !isEmail(b.email.trim()))
    errors.email = "Sila masukkan alamat email yang betul.";

  if (b.website.trim() && (b.website.includes(" ") || !b.website.includes(".")))
    errors.website = "Sila masukkan alamat website yang betul.";

  const addr = (a, prefix, label) => {
    if (!a.line1.trim()) errors[`${prefix}Line1`] = `Sila masukkan ${label}.`;
    else if (tooLong(a.line1, 80))
      errors[`${prefix}Line1`] = "Alamat terlalu panjang (maksimum 80 aksara).";

    if (a.line2.trim() && tooLong(a.line2, 80))
      errors[`${prefix}Line2`] = "Alamat terlalu panjang (maksimum 80 aksara).";

    if (!a.postcode.trim())
      errors[`${prefix}Postcode`] = prefix === "ba" ? "Sila masukkan poskod." : "Sila masukkan poskod penghantaran.";
    else if (a.country === "Malaysia" && !MY_POSTCODE.test(a.postcode.trim()))
      errors[`${prefix}Postcode`] = "Poskod Malaysia mesti 5 angka.";
    else if (a.country === "Singapore" && !SG_POSTCODE.test(a.postcode.trim()))
      errors[`${prefix}Postcode`] = "Poskod Singapura mesti 6 angka.";

    if (!a.city.trim())
      errors[`${prefix}City`] = prefix === "ba" ? "Sila masukkan bandar." : "Sila masukkan bandar penghantaran.";
    else if (tooLong(a.city, 50))
      errors[`${prefix}City`] = "Nama bandar terlalu panjang (maksimum 50 aksara).";

    if (a.country === "Malaysia" && !a.state)
      errors[`${prefix}State`] = prefix === "ba" ? "Sila pilih negeri." : "Sila pilih negeri penghantaran.";
  };

  addr(order.businessAddress, "ba", "alamat perniagaan");
  addr(order.shippingAddress, "sa", "alamat penghantaran");

  if (!order.productCode) errors.productCode = "Sila pilih jenis kad.";
  if (!order.templateId) errors.templateId = "Sila pilih design kad.";

  return errors;
};
